import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserAuthService } from 'src/app/core/services/user-auth.service';

@Component({
	selector: 'not-authorized',
	templateUrl: './not-authorized.component.html',
	styleUrls: ['./not-authorized.component.scss'],
	standalone: false
})
export class NotAuthorizedComponent implements OnInit {
	constructor(
		public readonly router: Router,
		private readonly userAuthService: UserAuthService,
		private readonly authService: AuthService
	) { }

	ngOnInit() { }

	public goHome(): void {
		this.router.navigate(['/']);
	}

	logout() {
		this.userAuthService.clearUserDetails();
		this.authService.logout();
	}
}
